module.exports = __webpack_public_path__ + "img/299.2615e0f4.jpg";